const NumberFormatterRegex = /\B(?=(\d{3})+(?!\d))/g

export const numberWithCommas = (number: string | number) => {
  return number.toString().replace(NumberFormatterRegex, ',')
}
